import React from 'react';
import { Helmet } from 'react-helmet';
import SimpleLoginForm from './components/SimpleLoginForm';
import Icon from '../../components/AppIcon';

const SimpleLogin = () => {
  return (
    <>
      <Helmet>
        <title>Simple Login - AuthorPreneur AI</title>
        <meta name="description" content="Simple email/password login for AuthorPreneur AI users" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/10 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="text-center space-y-4 mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
              <Icon name="BookOpen" size={32} color="var(--color-primary)" />
            </div>
            <h1 className="text-4xl font-bold text-foreground tracking-tight">
              Welcome Back
            </h1>
            <p className="text-lg text-muted-foreground">
              Sign in to your AuthorPreneur AI account
            </p>
          </div>

          <SimpleLoginForm />

          <div className="mt-8 text-center space-y-4">
            <div className="flex items-center justify-center space-x-2 text-sm text-muted-foreground">
              <Icon name="Shield" size={16} color="var(--color-muted-foreground)" />
              <span>Secure & encrypted connection</span>
            </div>
            <p className="text-xs text-muted-foreground">
              © {new Date()?.getFullYear()} AuthorPreneur AI. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SimpleLogin;